<div class="user-notification" [ngClass]="{ 'full-screen': visible }">
  <div (click)="showNotifications()" class="user-notification-trigger">
    <span>
      <i class="csx-common_notification"></i>
      <div class="user-notification-count" [hidden]="newNotificationCount === 0">{{ newNotificationCount }}</div>
    </span>
  </div>

  <div class="user-notification-wrapper" [hidden]="!visible">
    <div class="user-notification-header">
      <span class="header-text">NOTIFICATIONS ({{ notificationList.length }})</span>
    </div>
    <div class="user-notification-control">
      <div
        *ngFor="let item of notificationList; let i = index"
        [ngClass]="{ 'new-user-notification': !item.read, 'ui-state-disabled': !systemState.state }"
        class="user-notification-item"
        title="{{
          item.messageHeading
            ? item.messageHeading + item.messageBody
            : item.authorityMessage
            ? item.authorityMessage + ' ' + item.messageBody
            : item.messageBody
        }}"
        [hidden]="i > 2 && !(showAll || isSmallScreen)"
        (click)="openClickableNotification(item)"
      >
        <span *ngIf="!item.messageHeading">{{ item.authorityMessage }}</span
        ><br [hidden]="item.messageHeading || item.authorityMessage === ''" />
        <span [ngClass]="item.headerColor ? item.headerColor : ''">{{ item.messageHeading }}</span>
        {{ item.messageBody }}
      </div>
    </div>
    <div class="user-notification-footer">
      <span [hidden]="notificationList.length <= 2 || showAll || isSmallScreen" (click)="showAllElements()">View More</span>
    </div>
    <div class="ui-footer">
      <button type="button" class="notification-cancel" pButton label="Close" (click)="onClose()"></button>
    </div>
  </div>
  <div></div>
</div>
<user-confirmation-dialog
  *ngIf="authorityForUserConfirmation"
  [authority]="authorityForUserConfirmation"
  [action]="actionForUserConfirmation"
  (userAccept)="userAccepted($event)"
  (userCancel)="userCancelled($event)"
></user-confirmation-dialog>
